import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router"
import { VerifyEmailForm } from "@/features/auth/components/VerifyEmailForm"
import { AuthLayout } from "@/features/auth/components/AuthLayout"
import { z } from "zod"

const verifySearchSchema = z.object({
    email: z.string().email().optional(),
})

export const Route = createFileRoute("/auth/verify/")({
    validateSearch: verifySearchSchema,
    component: VerifyPage,
})

function VerifyPage() {
    const navigate = useNavigate()
    const { email } = Route.useSearch()
    const safeEmail = email || ""

    return (
        <AuthLayout>
            <VerifyEmailForm
                email={safeEmail}
                onSuccess={() => navigate({ to: "/auth/login" })}
            />
        </AuthLayout>
    )
}
